import endpoints from 'api/endpoints';
import { api } from 'api/rest';

export class GameService {
  static async finishGame(id: string) {
    const response = await api.post(`${endpoints.games}/finish/${id}`);
    return response;
  }
}
